import { useMemo } from 'react';

import { ModalBody, ModalWrapper, H3, P1 } from '@zooplus/ui-components';

import { usePaymentIncompleteModal } from '@hooks/use-payment-incomplete-modal';
import { useTranslation } from '@hooks/use-translations';
import PaymentIncompleteWarningIcon from '@public/images/payment-incomplete-warning-icon.svg';

import styles from './payment-incomplete-modal.module.scss';

const PaymentIncompleteModal = () => {
  const { t } = useTranslation();
  const { isModalOpen } = usePaymentIncompleteModal();

  const modalHeader = useMemo(
    () => (
      <div className={styles.modalHeaderWrapper}>
        <PaymentIncompleteWarningIcon data-testid="payment-incomplete-warning-icon" />
        <H3 className={styles.modalHeading}>
          {t('checkout.mobile.app.preview.payment.incomplete.title')}
        </H3>
      </div>
    ),
    [],
  );

  return (
    <ModalWrapper
      data-testid={`payment-incomplete-modal-${isModalOpen ? 'open' : 'closed'}`}
      isOpen={isModalOpen}
      className={styles.paymentIncompleteModal}
      closeBtnAriaLabel="cancel"
      headingId="payment-incomplete-modal"
      heading={modalHeader}
      size="sm"
      onClose={() => {}}>
      <ModalBody>
        <P1 className={styles.modalBodyText}>
          {t('checkout.mobile.app.preview.payment.incomplete.description')}
        </P1>
      </ModalBody>
    </ModalWrapper>
  );
};

export default PaymentIncompleteModal;
